export default __webpack_public_path__ + "static/media/34.171c5643.mp3";